import isEmpty from 'lodash/isEmpty';
import API from './../api';

export default {

    namespaced: true,

    state() {
        return {
            owner: null,
            metadata: {},
        };
    },

    getters: {
        owner: (state) => state.owner,
        metadata: (state) => state.metadata,
    },

    mutations: {
        gotOwner(state, response) {
            state.owner = response.data;
        },
        updatedOwner(state, response) {
            state.owner = response.data;
        },
        gotMetadata(state, response) {
            state.metadata = response.data || {};
        },
        resetOwner(state) {
            state.owner = null;
        }
    },

    actions: {
        async fetchOwner({ commit }, { id }) {
            commit('gotOwner', await API.get(`/app/owner/owner/${id}/`));
        },
        async createOwner({ commit }, payload) {
            const response = await API.post(`/app/owner/owner/`, payload);
            return response.data;
        },
        async updateOwner({ commit }, { id, ...payload }) {
            commit(
                'updatedOwner',
                await API.patch(`/app/owner/owner/${id}/`, payload)
            );
        },
        async updateTaxes({ commit }, { id, ...payload }) {
            commit(
                'updatedOwner',
                await API.put(`/app/owner/owner/${id}/update-taxes/`, payload)
            )
        },
        async updateAccess({ commit }, { id, ...payload }) {
            commit(
                'updatedOwner',
                await API.put(`/app/owner/owner/${id}/access/`, payload)
            )
        },
        async enableDisableAgreements({ commit }, { id, ...payload }) {
            commit(
                'updatedOwner',
                await API.post(`/app/owner/owner/${id}/enable-disable-agreements/`, payload)
            )
        },
        async sendEmail(_, { id, ...payload }) {
            const data = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                if (value) {
                    data.append(key, value);
                }
            })

            await API.post(`/app/owner/owner/${id}/send-email/`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        async fetchMetadata({ commit, state }, { force = false } = {}) {
            if (isEmpty(state.metadata) || force) {
                commit('gotMetadata', await API.get('/app/owner/metadata/'));
            }
        },
    },

};
